import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const isEditDashboardWithScroll = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return route === ERoutes.BOARD_EDIT_SCROLL;
}
